import React from 'react'

export default function Spinner() {
    return (
        <div class="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-white bg-opacity-75" style={{zIndex :"999"}} >
  <div class="spinner-border text-secondary" role="status" style={{width: "3rem", height: "3rem"}}>
    <span class="visually-hidden">Loading...</span>
  </div>
</div>

  )
}
